<template>
  <app-panel
    title="E-SIGN Consent"
    class="container"
    v-on:next="next"
    v-on:prev="prev"
    v-bind:showBack="false"
    v-bind:showNext="true"
  >
    <div
      class="row"
      style="max-height: 48vh; overflow: scroll"
      @scroll="onScroll"
    >
      <div class="legal-text col-md-12" id="input-group-consent">
        <h4 id="consent-title" style="text-align: center">
          <u>DISCLOSURE AND CONSENT TO THE USE OF ELECTRONIC COMMUNICATIONS</u>
        </h4>
        <p>
          As part of your relationship with us, we are required by law to give
          you certain information “in writing.” We may also need to obtain your
          signature to perform certain functions. If you prefer, you can choose
          to both receive information and to provide necessary signatures
          related to your relationship with us electronically, instead. In order
          to do this, we first need your consent to use electronic records and
          signatures.
        </p>
        <strong>
          <p>
            By providing your consent, you are consenting to the use of
            electronic records and signatures in connection with your
            relationship with us, and also confirming that:
          </p>
          <ul class="bullet-list">
            <li>You have reviewed this Disclosure and Consent,</li>
            <li>You have the hardware and software described below,</li>
            <li>You are able to receive and review electronic records, and</li>
            <li>
              You have an active email account and have provided the correct
              address to us.
            </li>
          </ul>
        </strong>
        <p>
          In this consent, the words “we,” “us,” and “our” means Valliani
          Jewelers, LLC. The words “you” and “your” means the person giving
          consent.
        </p>
        <p>
          “Communications” means each disclosure, notice, record, document or
          other information we provide to you, or that you sign or submit or
          agree to at our request, in connection with your relationship with us
          and any Service we provide.
        </p>
        <p>
          “Service” means each and every product or service we offer, provide to
          you, or that you apply for, own, use, administer or access, either now
          or in the future.
        </p>
        <ol class="numbers-list">
          <li>
            <p>
              <b>Scope of your consent.</b>
              Your consent applies to Communications related to all Services we
              may make accessible or available, or offer to you, whether through
              a website, software application, email, messaging services
              (including text messages), or otherwise. Your consent includes,
              but is not limited to, your credit card application with us and
              the servicing of your account.
            </p>
          </li>
          <li>
            <p>
              <b>Delivery of Communications.</b>
              In our sole discretion, the Communications we provide to you, or
              that you sign or agree to at our request, may be in electronic
              form (“Electronic Records”). We may also use electronic signatures
              and obtain them from you as part of our transactions with you.
              Electronic Records may be delivered to you by (i) posting on a
              website, (ii) email to you at the email address you provide to us,
              (iii) mobile application, (iv) accessing an online location that
              we designate in an e-mail, or other electronic notice we send to
              you at the time the Communication is available, or (v) other means
              we make available to you.
            </p>
            <p>
              We may always, in our sole discretion, provide you with any
              Communication in writing or send it to you via the U.S. mail or
              other means of delivery, even if you have chosen to receive it
              electronically. We may require any information you provide to us,
              or any document you sign, to be delivered to us in writing. You
              should print or download a copy of any Electronic Records for your
              own records, including this Disclosure and Consent.
            </p>
          </li>
          <li>
            <p>
              <b>Your option to receive paper copies.</b>
              If we provide an Electronic Record to you, and you want a paper
              copy, you may call Customer Service at 1.800.830.7820 and request
              a paper version. You may have to pay a fee for the paper copy
              unless charging a fee is prohibited by applicable law.
            </p>
          </li>
          <li>
            <p>
              <b
                >You may withdraw your consent at any time; Consequences of
                withdrawing consent; How to give notice of withdrawal.</b
              >
              You have the right to withdraw your consent at any time. Please be
              aware, however, that withdrawal of consent may result in the
              termination of your use of or access to certain Services. To
              withdraw your consent, contact Customer Service at 1.800.830.7820.
              Your withdrawal of consent will become effective after we have had
              a reasonable opportunity to act upon it.
            </p>
          </li>
          <li>
            <p>
              <b>You must keep your contact information current with us.</b>
              You must notify us immediately of any change to the email,
              telephone, or mailing addresses you provide to us (“Contact
              Information”). You can make changes to your Contact Information by
              calling Customer Service at 1.800.830.7820.
            </p>
          </li>
          <li>
            <p>
              <b>System Requirements.</b>
              In order to view and retain your electronic Communications, you
              will need:
            </p>
            <ul style="margin-bottom: 10px">
              <li>
                Internet access, a Current Version of an internet browser we
                support, and an email address;
              </li>
              <li>A printer or other storage device; and</li>
              <li>An active email address.</li>
            </ul>
            <p>
              You must have a computer or handheld device using a Current
              Version of an operating system capable of supporting all of the
              requirements described above. By “Current Version”, we mean a
              version of the software currently supported by its publisher. We
              reserve the right to discontinue support of a Current Version of
              software if, in our sole opinion, it suffers from a security flaw
              or other flaw that makes it unsuitable for our use of electronic
              Communications.
            </p>
            <p>
              If we change these hardware or software requirements, and that
              change creates a material risk that you would not be able to
              access or retain your electronic Communications, we will notify
              you of the revised hardware or software requirements, but you will
              continue to receive electronic Communications until you withdraw
              your consent.
            </p>
          </li>
        </ol>
        <br />
      </div>
    </div>
    <b-form-checkbox
      :disabled="!hitBottom"
      v-model="accepted"
      id="accept-checkbox"
      style="text-align: left"
      >I consent to the DISCLOSURE AND CONSENT TO THE USE OF ELECTRONIC
      COMMUNICATIONS</b-form-checkbox
    >
    <b-alert show variant="danger" v-for="error in errors" v-bind:key="error">{{
      error
    }}</b-alert>
  </app-panel>
</template>

<script>
import appPanel from "./appPanel.vue";
export default {
  components: { appPanel },
  data() {
    return {
      form: {},
      errors: [],
      accepted: false,
      hitBottom: false,
    };
  },
  methods: {
    validate() {
      if (this.accepted) return true;
      else this.errors = ["Please consent to continue"];
    },
    next() {
      if (this.validate()) this.$emit("next", {});
    },
    prev() {
      this.$emit("prev");
    },
    isNumber: function(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode === 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    onScroll({ target: { scrollTop, clientHeight, scrollHeight } }) {
      if (scrollTop + clientHeight >= scrollHeight - 1) {
        this.hitBottom = true;
      }
    },
  },
};
</script>
<style>
.alert {
  margin-top: 5px;
}
.selectable-input {
  background-color: white !important;
}
.input-group-sep {
  margin-right: -1px;
  margin-left: -1px;
}
.input-group-sep > .input-group-text {
  border-radius: 0;
}
.legal-text {
  text-align: justify !important;
  text-justify: inter-word !important;
  font-family: sans-serif !important;
  font-size: 14px !important;
}
.legal-text li,
p,
strong {
  text-align: justify !important;
  text-justify: inter-word !important;
  font-family: sans-serif !important;
  font-size: 14px !important;
}
.bullet-list {
  margin-left: auto;
  margin-right: auto;
}
.bullet-list li {
  text-align: left;
}
@media only screen and (max-width: 600px) {
  label {
    font-size: 15px;
  }
}
</style>
